import { render, staticRenderFns } from "./MyAccountCollectionSharedDetails.vue?vue&type=template&id=10d48143"
import script from "./MyAccountCollectionSharedDetails.vue?vue&type=script&lang=js"
export * from "./MyAccountCollectionSharedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports